import React, { useContext } from 'react';
import { AuthContext } from './AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import { translate } from './translateFunction'; // Import the translate function
import './UserRequest.css'; // Importiert die angepasste CSS-Datei für Video-Overlay

function Navigation() {
  const { user, logout, loading } = useContext(AuthContext);
  const navigate = useNavigate();
  
  // Video-bezogene States
  const videoRef = React.useRef(null);
  const [showVideo, setShowVideo] = React.useState(false);

  const handleLogout = async () => {
    const redirectPath = await logout();
    navigate(redirectPath);
  };

  const [translations, setTranslations] = React.useState({
    login: '',
    feedbackCollect: '',
    feedbackCapture: '',
    myFeedbacks: '',
    allFeedbacks: '',
    admin: '',
    logout: '',
    watchNewFeatures: ''
  });

  React.useEffect(() => {
    const loadTranslations = async () => {
      const login = await translate(300); // "Login"
      const feedbackCollect = await translate(301); // "Feedback einholen"
      const feedbackCapture = await translate(302); // "Feedback Erfassen"
      const myFeedbacks = await translate(303); // "Meine Feedbacks"
      const allFeedbacks = await translate(304); // "Alle Feedbacks"
      const admin = await translate(305); // "Admin"
      const logout = await translate(306); // "Ausloggen"
      const watchNewFeatures = await translate(916); // "Schau dir hier das neue Feature an!"

      setTranslations({
        login,
        feedbackCollect,
        feedbackCapture,
        myFeedbacks,
        allFeedbacks,
        admin,
        logout,
        watchNewFeatures
      });
    };

    loadTranslations();
  }, []);

  // Video-Handler-Funktionen
  const handleWatchNewFeatures = () => {
    setShowVideo(true);
  };

  const handleCloseVideo = () => {
    setShowVideo(false);
  };

  if (loading) {
    return null; // Show a loader if necessary
  }

  return (
    <nav className="navbar navbar-default">
      <div className="container-fluid">
        <div className="navbar-header">
          <a href="/" className="navbar-brand">
            {/* <img src="/dist/img/sc_logo.png" id="sc-logo" alt="swisscom-logo" /> */}
            <img src="/dist/img/clientecho_logo_5.png" id="sc-logo" alt="swisscom-logo" />
            
          </a>
          <button className="navbar-toggle" type="button" data-toggle="collapse" data-target="#navbar-main">
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
        </div>
        <div className="navbar-collapse collapse" id="navbar-main">
          <ul className="nav navbar-nav navbar-right">
            {!user ? (
              <>
                <li>
                  <Link 
                    to="#" 
                    onClick={handleWatchNewFeatures}
                    style={{ color: '#17a2b8', fontWeight: 'bold' }}
                  >
                    {translations.watchNewFeatures}
                  </Link>
                </li>
                <li><Link to="/login">{translations.login}</Link></li>
              </>
            ) : (
              <>
                <li><Link to="/customerFeedback">{translations.feedbackCollect}</Link></li>
                <li><Link to="/variousFeedback">{translations.feedbackCapture}</Link></li>
                <li><Link to="/User">{translations.myFeedbacks}</Link></li>

                {/* Show "Alle Feedbacks" only if the user has role 2 or 3 */}
                {(user.role === 2 || user.role === 3 || user.role === 4) && (
                  <li><Link to="/team">{translations.allFeedbacks}</Link></li>
                )}

                {user.role === 3 && (
                  <li><Link to="/admin">{translations.admin}</Link></li>
                )}
                <li><Link to="#" onClick={handleLogout}>{translations.logout}</Link></li>
              </>
            )}
          </ul>
        </div>
      </div>

      {/* Video-Overlay */}
      {showVideo && (
        <div className="overlay">
          <div className="video-container">
            <video
              ref={videoRef}
              controls
              className="video-player"
              style={{ backgroundColor: 'black' }}
            >
              <source
                src="/dist/video/clientEcho_NewFeatures.mp4"
                type="video/mp4"
              />
              Dein Browser unterstützt dieses Video nicht.
            </video>
            <button className="close-button" onClick={handleCloseVideo}>
              X
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}

export default Navigation;
